import React from 'react';
import PanelLoading from '../../components/panelLoading';
import OrderDetail from './orderDetail';
import { isMobile } from '../../constants';

class CreateOrder extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            clicked: false
        };
        this.nextStep = this.nextStep.bind(this);
        this.clickAutoSave = this.clickAutoSave.bind(this);
    }
    componentWillReceiveProps(nextProps) {
        if (this.state.clicked === true && nextProps.createOrderDone === true && this.props.createOrderDone === false) {
            // neweb 一律 redirectURL
            if (['3', 3, '1', 1, '53', 53, '51', 51, '52', 52, '53', 55].indexOf(nextProps.order.paymentMethodId) >= 0) {
                window.location = nextProps.order.redirectURL;
            } else {
                this.props.jumpToStep(3);
            }
        }
    }
    clickAutoSave(value) {
        this.props.updateData({ autoTake: value });
    }
    nextStep() {
        if (!this.state.clicked && !this.props.loading) {
            this.setState({ clicked: true }, () => {
                this.props.createOrder({
                    payerAutoTake: this.props.data.autoTake,
                    paymentMethodId: this.props.data.paymentMethod,
                    specId: this.props.data.spec,
                    invType: this.props.data.invType,
                    invCity: this.props.data.cityCode,
                    invTown: this.props.data.townCode,
                    invAddr: this.props.data.address,
                    invTitle: this.props.data.invTitle,
                    invTaxNo: this.props.data.invTaxNo,
                    payerName: this.props.data.name,
                    payerPhone: this.props.data.phone,
                    payerGender: this.props.data.gender,
                    payerEmail: this.props.data.email,
                    medium: isMobile ? 6 : 5
                });
            });
        }
    }
    render() {
        const { clicked } = this.state;
        const { loading, jumpToStep, data, userInfo, paymentMethods } = this.props;
        return (
            <div className="panel panel-default" style={{ marginTop: '30px' }}>
                <div className="panel-heading">Step3. 建立訂單</div>
                <div className="panel-body" style={{ position: 'relative' }}>
                    {(loading || clicked) && <PanelLoading />}
                    <p>請確認以下資料是否無誤，然後點擊「下一步」</p>
                    <hr />
                    <OrderDetail userInfo={userInfo} data={data} paymentMethods={paymentMethods}/>
                    <p className="text-center">
                        <button
                            className={data.autoTake ? 'btn btn-pubgame' : 'btn btn-default'}
                            onClick={() => this.clickAutoSave(!data.autoTake)}>
                            <span
                                className={data.autoTake ? 'glyphicon glyphicon-check' : 'glyphicon glyphicon-unchecked'}
                                style={{ float: 'left', fontSize: '20px', marginTop: '-2px' }}>
                            </span>
                            {'  下次儲值自動帶入資料'}
                        </button>
                    </p>
                    <hr />
                    <button className="btn btn-default" onClick={() => jumpToStep(1)}>上一步</button>
                    <button
                        className={(loading || clicked) ? 'btn btn-pubgame disabled' : 'btn btn-pubgame'}
                        disabled={loading || clicked}
                        style={{ float: 'right' }}
                        onClick={this.nextStep}>
                        下一步
                    </button>
                </div>
            </div>
        );
    }
}

export default CreateOrder;


// WEBPACK FOOTER //
// ./src/containers/shop/createOrder.jsx